import { render, staticRenderFns } from "./AddShipDetailsModal.vue?vue&type=template&id=c51ecad0"
import script from "./AddShipDetailsModal.vue?vue&type=script&lang=js"
export * from "./AddShipDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./AddShipDetailsModal.vue?vue&type=style&index=0&id=c51ecad0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports